import { useCallback, useState } from 'react';

import request from '@/services/request';

import {
  TFetchInspectionProps,
  TInspectionPropsPaginationResults,
  TInspectionQuantityResponse,
} from './types';

export const useFetchInspection = () => {
  const [data, setData] = useState<TInspectionPropsPaginationResults>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const fetchInspection = useCallback(
    async ({
      property_code,
      start_date,
      end_date,
      owner_name,
      page,
      page_size,
    }: TFetchInspectionProps) => {
      setLoading(true);
      try {
        const response = await request.get(
          `/property/inspections/?${property_code ? `property_code=${property_code}&` : ''}${
            start_date ? `start_date=${start_date}&` : ''
          }${end_date ? `end_date=${end_date}&` : ''}${
            owner_name ? `owner_name=${owner_name}&` : ''
          }${page ? `page=${page}&` : ''}${page_size ? `page_size=${page_size}` : ''}`,
        );
        setData(response.data);
      } catch (err: any) {
        setData(undefined);
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { data, loading, error, fetchInspection };
};

export const useFetchInspectionQuantity = () => {
  const [data, setData] = useState<TInspectionQuantityResponse>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const fetchInspectionQuantity = useCallback(async () => {
    setLoading(true);
    try {
      const response = await request.get(`/property/inspections/quantity`);
      setData(response.data);
    } catch (err: any) {
      setData(undefined);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  return { data, loading, error, fetchInspectionQuantity };
};
